import { Component, input } from '@angular/core';
import { NavLink } from '@welma-education/common';

import { RouterModule } from '@angular/router';
import { TabsWithUnderlineVertical } from '../tabs-with-underline-vertical/tabs-with-underline-vertical';
import { TabsWithUnderlineHorizontal } from '../tabs-with-underline-horizontal/tabs-with-underline-horizontal';

@Component({
  selector: 'wma-nav-tabs-with-underline',
  templateUrl: './nav-tabs-with-underline.html',
  imports: [RouterModule, TabsWithUnderlineVertical, TabsWithUnderlineHorizontal],
})
export class NavTabsWithUnderline {
  readonly links = input.required<NavLink[]>();
}
